import React from 'react';
import PropTypes from 'prop-types';
import {
  Row, Col,
} from 'antd';
import { useTranslation } from 'react-i18next';
import {
  CompanyDetailsHeader,
  CompanyDetailsHeaderDescription,
} from './Forms';

const FillCompanyHeader = ({ view }) => {
  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Col span={4} />
        <Col span={16}>
          <Row
            type="flex"
            style={{ alignItems: 'center', marginTop: '10px' }}
            justify="center"
            gutter={10}
          >
            <CompanyDetailsHeader>{t('FORM_FILL_COMPANY.HEADER')}</CompanyDetailsHeader>
          </Row>
        </Col>
        <Col span={4} />
      </Row>
      <Row>
        <Col span={2} />
        <Col span={20}>
          <Row
            type="flex"
            style={{ alignItems: 'center', marginTop: '-15px' }}
            justify="center"
            gutter={10}
          >
            <CompanyDetailsHeaderDescription>
              { view === undefined ? (
                <>{t('FORM_FILL_COMPANY.HEADER_DESC')}</>
              ) : (
                <></>
              )}
            </CompanyDetailsHeaderDescription>
          </Row>
        </Col>
        <Col span={2} />
      </Row>
    </>
  );
};

export default FillCompanyHeader;

FillCompanyHeader.propTypes = {
  view: PropTypes.string.isRequired,
};
